import { render, staticRenderFns } from "./welfares.vue?vue&type=template&id=28bbfb53&scoped=true"
import script from "./welfares.vue?vue&type=script&lang=js"
export * from "./welfares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bbfb53",
  null
  
)

export default component.exports